import React from 'react';
import { Layout } from './Layout';
import { Attention } from '../atoms/Attention';

export const NotFoundPage = () => {
  return (
    <Layout>
      <div style={{ backgroundColor: '#fff' }}>
        <Attention title="指定されたページが見つかりません">
          エラー ： 404 Not Found
          <br />
          <br />
          ページが削除された、またはURL（ページアドレス）が変更された可能性があります。
        </Attention>
      </div>
    </Layout>
  );
};
